import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { suretyKeys } from "@/lib/query-keys";
import type { SuretyClient } from "@/types/surety";

/** Los clientes de la cartera con su último triunfo y su ficha OECE. */
export function useSuretyClients(enabled = true) {
  return useQuery({
    queryKey: suretyKeys.clients(),
    enabled,
    queryFn: async () => {
      const res = await fetchToBackend<{ data: SuretyClient[] }>("/surety/clients");
      return res.data;
    },
  });
}
